<template>
	<Page>
		<div class="centered">
			<Breadcrumb :crumbs="[
					{
						text : 'Home',
						to : {name:'templates'},
					},
					{
						text : 'Settings',
						to : {name:'settings'},
					},
				]" />
			<UserPageNav />
			<h1>Profile settings</h1>
			<div class="raised-box p-box">
				<SimpleForm
						:onSubmit="onSubmit"
						:fields="[
							{
								label : 'First name',
								name : 'first_name',
								autofocus : true,
								required : true,
								// label_help : 'Accepts alphanumeric characters and underscores.',
							},
							{
								label : 'Last name',
								name : 'last_name',
								required : true,
							},
						]"
						:model="user"
					/>
			</div>
		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page'
	import UserPageNav from '../components/UserPageNav';
	import Breadcrumb from '../components/Breadcrumb';

	export default {
		components: {UserPageNav,Breadcrumb},
		mixins : [Page],
		data(){
			return {
				user : this.$store.state.auth.user,
			}
		},
		methods:{
			onSubmit(payload){
				var self = this;
				return this.$store.dispatch('auth/updateUser',payload);
			},
		},
	}

</script>